import classes from "./About.module.scss";
import Deexit from "../../images/Deexit.png";
import PDF from "../../images/frontend_developer.pdf";

const About = (props) => {
  const { isDark } = props;
  const handlePDF = () => {
    window.open(PDF);
  };
  return (
    <div className={classes.about} id="about">
      <div
        className={classes.backgroundCircle}
        style={{
          border: isDark
            ? "3px solid rgba(254, 254, 254, 0.212)"
            : "3px solid rgba(9, 9, 22, 0.212)",
        }}
      >
        <div
          className={classes.innerCircle}
          style={{
            border: isDark
              ? "3px solid rgba(254, 254, 254, 0.212)"
              : "3px solid rgba(9, 9, 22, 0.212)",
            backgroundColor: isDark ? "#090916" : "#fefefe",
          }}
        ></div>
      </div>
      <div className={classes.about_flex}>
        <div
          className={classes.about_flex_image}
          style={{
            boxShadow: isDark
              ? "0px -50px 60px #090916 inset"
              : "0px -50px 60px #fefefe inset",
          }}
        >
          <img
            src={Deexit}
            alt="Deexit"
            style={{
              mixBlendMode: isDark ? "darken" : "lighten",
            }}
          />
        </div>
        <div className={classes.about_flex_content}>
          <div className={classes.about_heading}>About Me</div>
          <div
            className={classes.about_content}
            style={{ color: isDark ? "#fefefe" : "#090916" }}
          >
            I'm a Frontend Web Developer building the Front-end of Websites and
            Web Applications that leads to the success of the overall product.
            Check out some of my work in the Projects section.
          </div>
          <div
            className={classes.about_content}
            style={{ color: isDark ? "#fefefe" : "#090916" }}
          >
            I'm open to Job opportunities where I can contribute, learn and
            grow. If you have a good opportunity that matches my skills and
            experience then don't hesitate to contact me.
          </div>
          <button
            href="../../public/frontend_developer.pdf"
            target="_blank"
            className={
              isDark
                ? classes.about_button
                : [classes.about_button, classes.about_button_light].join(" ")
            }
            onClick={handlePDF}
          >
            Resume
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
